import React, { useState } from "react";
import CSBoard from "pages/csboard/CSBoard";
import { useSelector } from "react-redux";
import qs from "qs";

const CSBoardContainer = ({ location }) => {
	const query = qs.parse(location.search, {
		ignoreQueryPrefix: true,
	});

	const loginInfo = useSelector((state) => state.loginReducer);
	const mode = useSelector((state) => state.settingReducer.mode);
	const [type, setType] = useState(query.tab || "anounList");
	const [paramSeq, setParamSeq] = useState(query.PARAM_SEQ);

	const myInfo = {
		userId: loginInfo.userId,
		userSeq: loginInfo.mmbrSeq,
		// userNm: loginInfo.mmbrName,
		// days: "",
		// date: "",
		// messages: "",
		// alert: "",
		// rating: "",
	};

	return (
		<>
			<CSBoard
				myInfo={myInfo}
				mode={mode}
				type={type}
				setType={setType}
				paramSeq={paramSeq}
				setParamSeq={setParamSeq}
			/>
		</>
	);
};

export default CSBoardContainer;
